import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { CustomerNoteServiceProxy, CustomerServiceProxy } from '../../../../shared/service-proxies/event-service-proxy';
import { takeUntil } from 'rxjs';
import { NoteActionEventModel, NoteActions, NoteModel } from '../../../data/common/note.dataclass';

@Component({
    selector: 'app-text-area',
    templateUrl: './text-area.component.html',
    styleUrls: ['./text-area.component.scss'],
    providers: [DestroyService],
    standalone: false
})
export class TextAreaComponent implements OnChanges {
  @Input() note: NoteModel = new NoteModel();
  @Input() isEditing: boolean = false;
  @Output() actionEvent = new EventEmitter<NoteActionEventModel | null>(null);
  @Output() closeEvent = new EventEmitter();

  noteText: string = "";
  btnCreateVisible: boolean = false;
  btnEditVisible: boolean = false;

  selectedEditTextVisible: boolean = false;
  selectedEditTextCardHeight = new EventEmitter<number>();

  constructor(private cdr: ChangeDetectorRef) { }

  @ViewChild('cardElement') cardElement!: ElementRef;
  ngOnChanges() {
    if (this.isEditing) {
      this.btnEditVisible = true;
      this.noteText = this.note.text;
      this.cdr.detectChanges();
      if (this.cardElement) {
        this.emitCardHeight();
      }
    }
  }
  emitCardHeight() {
  if (this.cardElement?.nativeElement) {
    const height = this.cardElement.nativeElement.offsetHeight;
    this.selectedEditTextCardHeight.emit(height);
  }
  }

  createNote() {
    this.actionEvent.emit({ action: NoteActions.create, note: { files: this.note.files, text: this.noteText} });
    this.note = new NoteModel();
    this.noteText = "";
  }
  updateNote() {
      this.actionEvent.emit({ action: NoteActions.update, note: { files: this.note.files, text: this.noteText} });
      this.note = new NoteModel();
      this.noteText = "";
  }
  handleKeyDown(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey || event.shiftKey) && event.key === 'Enter') {
      this.noteText += '\n';
      event.preventDefault();
    } else if (event.key === 'Enter') {
      if (this.isEditing) {
        this.updateNote();
      } else {
        this.createNote();
      }
      event.preventDefault();
    }
  }
  writeText(event: Event) {
    const target = event.target as HTMLTextAreaElement;
    this.noteText = target.value;
  }

  closeSelectedEditText() {
    this.btnEditVisible = false;
    this.noteText = ''
    this.closeEvent.emit();
  }
}
